/**
 * @fileoverview Requirement metadata panel shown above the proposals list.
 */
import { Switch, SvgIcon } from "@mui/material";
import dayjs from "dayjs";
import { ReactComponent as CalendarIcon } from "../../assets/icons/ValidationPage/CalendarIcon.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/Location_on.svg";
import { generateAssetUrl } from "../../utils/common.js";
import AssetImage from "../AssetImage";

const ProposalsListRequirementSummary = ({
  requirement,
  isActive,
  onToggleActive,
  t,
  styles,
}) => (
  <>
    <div className={styles.descriptionContainer}>
      <label className={styles.modalSubtitle}>
        {t("components.requirementDisplayModal.description")}
      </label>
      <span>{requirement.descripcion}</span>
    </div>
    <div className={styles.locationContainer}>
      <label className={styles.modalSubtitle}>
        {t("components.requirementDisplayModal.location")}
      </label>
      <div className={styles.locationItem}>
        <SvgIcon sx={{ fontSize: "16px" }} component={LocationIcon} />
        <span>{requirement.ubicacion}</span>
      </div>
    </div>
    <div className={styles.dueDateContainer}>
      <label className={styles.modalSubtitle}>
        {t("components.requirementDisplayModal.dueDate")}
      </label>
      <div className={styles.dueDateItem}>
        <SvgIcon sx={{ fontSize: "16px" }} component={CalendarIcon} />
        <span>{dayjs(requirement.fechaLimite).utc().format("LLL")}</span>
      </div>
    </div>
    <div className={styles.dueDateContainer}>
      <label className={styles.modalSubtitle}>
        {t("components.requirementDisplayModal.minimumExperience")}
      </label>
      <span>
        {requirement.experienciaMinima
          ? `${requirement.experienciaMinima} ${t("components.requirementDisplayModal.years")}`
          : t("common.notAvailable")}
      </span>
    </div>
    <div className={styles.certificationsContainer}>
      {requirement.certificaciones?.length > 0 && (
        <div className={styles.certificationHeader}>
          <label style={{ width: "60%" }} className={styles.modalSubtitle}>
            {t("components.requirementDisplayModal.certifications")}
          </label>
        </div>
      )}
      {requirement.certificaciones?.length > 0 &&
        requirement.certificaciones.map((certification, index) => (
          <div key={index} className={styles.certificationItem}>
            <span style={{ width: "60%" }}>{certification.nombre}</span>
          </div>
        ))}
    </div>
    {requirement.urlImagen && (
      <div className={styles.imageContainer}>
        <AssetImage
          className={styles.image}
          src={generateAssetUrl(requirement.urlImagen)}
          alt={t("common.requirementImageAlt")}
        />
      </div>
    )}
    <div className={styles.toggleContainer}>
      <span className={styles.toggleText}>
        {t("components.proposalsListModal.activateDeactivateRequirement")}
      </span>
      <Switch checked={isActive} onChange={onToggleActive} color="primary" />
    </div>
  </>
);

export default ProposalsListRequirementSummary;
